<script>
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { api } from "src/plugins/axios";
import { date } from "quasar";
import { notify } from "src/plugins/notify";
import ClassStudentDetails from "../Class/ClassStudentDetails";
import ShareMeetingLinkModal from "./ShareMeetingLinkModal";

export default {
  components: {
    ClassStudentDetails,
    ShareMeetingLinkModal
  },
  props: ["validation", "addressError"],
  data() {
    return {
      affiliateFilter: '',
      currentAffiliateLabel: '',
      classTypes: [
        { label: 'In Classroom', value: 1 },
        { label: 'Distance Learning', value: 2 }
      ]
    }
  },
  async created() {
    let vm = this;
    vm.$root.$on("refreshClassesModalUI", vm.refreshClassesModalUI)

    let affiliate = vm.sessionInformation.selectedAffiliateObject
    if( affiliate && vm.sessionInformation.selectedAffiliate ){
      vm.onSelectAffiliate(affiliate, false, { initial: true })
    }
    if(!vm.sessionInformation.selectedClassType){
      vm.onUpdateSelectedClassType(1)
    }
  },
  beforeDestroy(){
    this.$root.$off("refreshClassesModalUI", this.refreshClassesModalUI)
  },
  computed: {
    ...mapGetters("classes", ["getAddEditClassOpenState"]),
    ...mapGetters(["stateOptions"]),
    ...mapState({
      meetingLinkModal: s => s.classes.meetingLinkModal,
      sessionInformation: s => s.classes.sessionInformation,
      currentSessionIndex: s => s.classes.currentSessionIndex,
      selectedTab: s => s.classes.selectedTab,
      dateFormat: s => s.shared.formats.datetime,
      loading: s => s.classes.sessionInformation.loading,
      canEdit: s => s.classes.canEdit,
      mode: s => s.classes.sessionInformation.mode,
      availableInstructors: s => s.classes.sessionInformation.availableInstructors,
      // time lookups
      hours: s => s.shared.time.hours,
      minutes: s => s.shared.time.minutes,
      period: s => s.shared.time.period
    }),
    isValidMeetingLink(){
      let link = this.sessionInformation.meetingLink,
          pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      return !!pattern.test(link)
    },
    titleLabel() {
      return this.sessionInformation.mode === "add"
        ? "Add Class"
        : "Edit Class " + this.sessionInformation.classId
    },
    saveLabel() {
      return this.sessionInformation.mode === "add" ? "Create" : "Save"
    },
    classValidation() {
      return this.validation.sessionInformation
    },
    remainingInstructorsCount() {
      let vm = this
      let availableInstructors = vm.sessionInformation.availableInstructors
      let currentInstructors = vm.currentSessionOrFirst("Instructors").instructors
      return availableInstructors.length - currentInstructors.length
    },
    courseErrorLabel() {
      let vm = this;
      let coursesCount = vm.sessionInformation.courses.length
      if (coursesCount === 0) {
        return "No Available Courses. Please Contact your Administrator."
      } else if (
        coursesCount > 0 &&
        vm.sessionInformation.selectedCourse == null
      ) {
        return "Please Select a Course!"
      }
    },
  },
  methods: {
    ...mapActions("classes", [
      "upsertCalendarClass",
      "removeSession",
      "loadInstructorsForAffiliate",
      "loadCoursesForAffiliate",
      'affiliateAutocomplete'
    ]),
    ...mapMutations("classes", [
      "setCurrentSessionIndex",
      "updateSelectedTab",
      "updateAddNewSession",
      "updateAddNewInstructor",
      "updateAutocompleteInstructor",
      "updateAddEditClassOpenState",
      "selectAffiliateForCurrentClass",
      "clearInstructors",
      "clearCourse",
      "autocompleteAddressSessionUpdate",
      "setClassAffiliateSearch",
      "updateSelectedClassType",
      "setMeetingLinkModal"
    ]),
    refreshClassesModalUI(){
      this.forceUpdate()
    },
    onUpdateSelectedClassType(v){
      this.updateSelectedClassType(v)
      this.$nextTick(() => {
        this.forceUpdate()
      })
    },
    currentValidation(sync) {
      if (sync) {
        return this.validation.sessionInformation.sessions.$each[
          this.currentSessionOrFirst(sync, true)
        ];
      }
      return this.validation.sessionInformation.sessions.$each[
        this.currentSession(true)
      ];
    },
    allSessionIds() {
      return _.map(this.sessionInformation.sessions, session => {
        return session.sessionId
      });
    },
    onRemove(sessionIndex) {
      this.$q.dialog(this.removeDialogOptions(sessionIndex)).then(() => {
        this.removeSession(sessionIndex)
      });
    },
    currentSession(findIndex) {
      var filter = findIndex === true ? "findIndex" : "find"
      //this.setCurrentSessionIndex(_.findIndex(this.sessionInformation.sessions, { value: this.sessionInformation.selected }))
      // console.log('date', date.formatDate(this.dateFormat, _[filter](this.sessionInformation.sessions, {value: this.sessionInformation.selected})))
      return _[filter](this.sessionInformation.sessions, {
        value: this.sessionInformation.selected
      });
    },
    currentSessionOrFirst(type, returnSessionIndex) {
      let firstSession = this.sessionInformation.sessions[0]
      let syncType = this.currentSession()[`sync${type}`]
      if (returnSessionIndex) {
        return syncType === true ? 0 : this.currentSession(true)
      }
      return syncType === true ? firstSession : this.currentSession()
    },
    isFirstSession() {
      return (
        this.currentSession().label ===
        this.sessionInformation.sessions[0].label
      );
    },
    ifEmptySetEndDate() {
      if(!this.currentSession().endDate) {
        this.currentSession().endDate = this.currentSession().startDate
      }
    },
    disableAddressForCurrentSession() {
      let vm = this
      if ( !vm.isFirstSession() && vm.currentSession().syncAddress === true ) {
        return true
      } else if (this.isFirstSession()) return false
    },
    disableMaxStudentsForCurrentSession() {
      let vm = this
      if ( !vm.isFirstSession() && vm.currentSession().syncMaxStudents === true ) { return true }
      return false
    },
    forceUpdate(ms) {
      let parent = this
      setTimeout(() => {
        parent.$forceUpdate()
      }, ms || 250)
    },
    onDropdownFocus(index) {
      let dropdown = this.$refs[index]
      dropdown.show()
    },
    removeDialogOptions(sessionId) {
      let message = `Are you sure you want to remove ${this.currentSession().label}?`
      let titleText = "Session"

      return {
        title: `Remove ${titleText}`,
        message: message,
        noBackdropDismiss: true,
        ok: {
          label: "Yes, I'm Sure.",
          color: "positive"
        },
        cancel: {
          label: "Cancel",
          color: "grey"
        }
      };
    },
    loadInstructorsForAffiliateMethod(selectedAffiliateId, bypassCheck, options) {
      const vm = this
      let callback = options ? options.callback : null
      let initial = options ? options.initial : null

      if ( (vm.currentSessionOrFirst("Instructor").instructors.length > 0 || bypassCheck) && !initial ) {
        vm.$q
          .dialog({
            title: `Reassigning Affiliate Warning`,
            message: "Your previous instructors will be cleared. Continue?",
            noBackdropDismiss: true,
            ok: {
              label: "Yes, I'm Sure.",
              color: "positive"
            },
            cancel: {
              label: "Cancel",
              color: "grey"
            }
          })
          .then(() => finishProcess(true))
          .catch(() => {
            if(vm.sessionInformation.selectedAffiliate){
              vm.affiliateFilter = vm.currentAffiliateLabel
            }
          })
      }
      else {
        finishProcess()
      }

      function finishProcess(clear) {
        if(!initial){
          if (clear) vm.clearInstructors(vm.currentSessionOrFirst("Instructors", true))
          vm.clearCourse()
          vm.selectAffiliateForCurrentClass(selectedAffiliateId)
          vm.loadInstructorsForAffiliate(selectedAffiliateId)
          vm.loadCoursesForAffiliate({
            affiliateId: selectedAffiliateId,
            classId: vm.sessionInformation.classId
          })
        }
        if (callback) callback()
      }
    },
    remainingInstructors(currentInstructor) {
      let vm = this;
      let availableInstructors = vm.availableInstructors;
      let allSelectedInstructors = vm.currentSessionOrFirst("Instructors")
        .instructors;
      let finalInstructors = _.filter(
        availableInstructors,
        availableInstructor => {
          if (availableInstructor.value == currentInstructor) {
            return true
          }
          if (allSelectedInstructors.indexOf(availableInstructor.value) > -1) {
            return false
          } else {
            return true
          }
        }
      );
      return finalInstructors;
    },
    getCourses() {
      return this.sessionInformation.courses
    },
    placeChange(place) {
      let vm = this
      vm.autocompleteAddressSessionUpdate({
        sessionId: vm.currentSessionOrFirst("Address", true),
        place,
        stateOptions: vm.stateOptions
      });
    },
    onSelectAffiliate(selectedAffiliate, bypass, options){
      let vm = this
      vm.loadInstructorsForAffiliateMethod(selectedAffiliate.item.AFFILIATE_ID, bypass, {
        initial: options ? options.initial : null,
        callback:() => {
          vm.setClassAffiliateSearch(selectedAffiliate)
          vm.currentAffiliateLabel = selectedAffiliate ? `${selectedAffiliate.value} - SPF $${selectedAffiliate.item.STUDENT_PROCESSING_FEE}` : null
          vm.affiliateFilter = selectedAffiliate ? selectedAffiliate.value : null
        }
      })
    },
    async onAffiliateAutocomplete(s, done){
      let vm = this
      let results = await vm.affiliateAutocomplete({ search: s })
      vm.currentAffiliateLabel = (results.length == 0 && !vm.currentAffiliateLabel) ? 'No Matching Affiliates' : vm.currentAffiliateLabel
      done(results)
    },
    checkAddressError(field) {
      if (this.addressError) {
        const sessionIdx = this.currentSession(true)
        if (this.addressError.sessionIdx == sessionIdx) {
          return this.addressError.fields.includes(field)
        }
      }

      return false
    }
  },
};
</script>

<template>
  <div id="sessionDetails">
    <div class="sl-row">
      <div class="sl-col-6">
        <h5>Affiliate</h5>
        <!--
        <q-field :error="classValidation.selectedAffiliate.$error" error-label="Required">
          <q-select
            :value="sessionInformation.selectedAffiliate"
            :disable="!canEdit"
            float-label="Affiliate*"
            :after="[
              {icon: 'flag', condition: classValidation.selectedAffiliate.$invalid },
              {icon: 'fa fa-check', condition: !classValidation.selectedAffiliate.$invalid}
            ]"
            filter
            autofocus-filter
            @change="val => loadInstructorsForAffiliateMethod(val)"
            :options="sessionInformation.affiliates" />
        </q-field> -->
        <q-field
          style="margin-top:12px"
          :error="classValidation.selectedAffiliate.$error"
          error-label="Required" :helper="currentAffiliateLabel">
          <q-input
            :before="[{icon: 'fa fa-building'}]"
            :after="[
              {icon: 'flag', condition: classValidation.selectedAffiliate.$invalid },
              {icon: 'fa fa-check', condition: !classValidation.selectedAffiliate.$invalid}
            ]"
            placeholder="Search for Affiliate"
            :disable="!canEdit"
            :clear-value="null"
            clearable
            @blur="classValidation.selectedAffiliate.$touch"
            @clear="loadInstructorsForAffiliateMethod()"
            v-model="affiliateFilter">
            <q-autocomplete                      
              :debounce="500"
              :max-results="10"
              @search="onAffiliateAutocomplete"
              @selected="onSelectAffiliate"
            />
          </q-input>
        </q-field>
      </div>
      
      <div class="sl-col-6">
        <h5>
          Instructors
          <q-btn
            v-if="((!currentSession().syncInstructors && !isFirstSession()) || isFirstSession()) && canEdit && sessionInformation.selectedAffiliate && (remainingInstructorsCount > 0)"
            icon="add"
            id="addInstructor"
            @click="updateAddNewInstructor({ sessionIndex: currentSessionOrFirst('Instructors',true) })"
          >
            <q-tooltip anchor="center right" self="center left" :offset="[10, 10]">Add an Instructor</q-tooltip>
          </q-btn>
          <span v-if="!isFirstSession()">
            <q-checkbox :disable="!canEdit" v-model="currentSession().syncInstructors" />
            <span>Sync with First Session</span>
          </span>
          <q-btn
            color="red"
            v-if="currentSessionOrFirst('Instructors').instructors.length === 0 && canEdit && sessionInformation.selectedAffiliate && (remainingInstructorsCount > 0)"
            @click="updateAddNewInstructor({ sessionIndex: currentSessionOrFirst('Instructors', true) })"
          >
            <span>Please Add an Instructor!</span>
          </q-btn>
          <span
            class="no-affiliate-label"
            v-if="!sessionInformation.selectedAffiliate"
          >Please select an affiliate!</span>
          <span
            class="no-affiliate-label"
            v-if="sessionInformation.selectedAffiliate && sessionInformation.availableInstructors.length == 0"
          >No Instructors Associated to this Affiliate.</span>
        </h5>
        <div class="sl-row" v-if="sessionInformation.availableInstructors.length > 0">
          <div
            class="sl-col-12 instructor-field"
            :key="i"
            v-for="(instructor,i) in currentSessionOrFirst('Instructors').instructors"
          >
            <q-field 
              :error="currentSessionOrFirst('Instructors').instructors[i].value"
              error-label="Instructor is required">
              <q-select
                :disable="!canEdit"
                :before="[{icon: 'fa fa-graduation-cap'}]"
                :options="remainingInstructors(instructor)"
                v-model="currentSessionOrFirst('Instructors').instructors[i]"
                placeholder="Select Instructor"
                float-label="Instructor"
                filter
                autofocus-filter
                ref="instructorDropdowns"
              />
            </q-field>

            <q-btn
              outline
              color="red"
              v-if="canEdit"
              @click.native="updateAddNewInstructor({instructorIndex: i, sessionIndex: currentSessionOrFirst('Instructors', true), delete: true})"
              icon="fa fa-trash-o"
              class="delete"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="sl-row">
      <div class="sl-col-12">
        <h5>Date &amp; Time</h5>
      </div>
    </div>
    <div class="sl-row">
      <div class="sl-col-6 time-container">
        <q-field
          :error="currentValidation().startDate.$error"
          error-label="Start Date Required"
          style="width:40%;margin-right:4%"
        >
          <q-datetime
            @blur="currentValidation().startDate.$touch; ifEmptySetEndDate()"
            v-model="currentSession().startDate"
            :disable="!canEdit"
            :max="currentSession().endDate"
            :min="$p(['ADMIN']) ? null : currentSession().minStart"
            :before="[{icon: 'calendar_today' }]"
            inverted-light
            color="grey-3"
            type="date"
            format="MM/DD/YYYY"
            float-label="Start Date*"
            popover
          />
        </q-field>
        <q-field
          :error="currentValidation().startHour.$error"
          error-label="Required"
          style="width:15%"
        >
          <q-select
            :disable="!canEdit"
            stack-label="Time*"
            :value="currentSession().startHour"
            @blur="currentValidation().startHour.$touch"
            filter
            autofocus-filter
            :options="hours"
            v-model="currentSession().startHour"
          />
        </q-field>
        <q-field
          :error="currentValidation().startMin.$error"
          error-label="Required"
          style="width:15%"
        >
          <q-select
            :disable="!canEdit"
            float-label=" "
            :value="currentSession().startMin"
            @blur="currentValidation().startMin.$touch"
            filter
            autofocus-filter
            :options="minutes"
            v-model="currentSession().startMin"
          />
        </q-field>
        <q-field
          :error="currentValidation().startPeriod.$error"
          error-label="Required"
          style="width:15%"
        >
          <q-select
            :disable="!canEdit"
            float-label=" "
            :value="currentSession().startPeriod"
            @blur="currentValidation().startPeriod.$touch"
            filter
            autofocus-filter
            :options="period"
            v-model="currentSession().startPeriod"
          />
        </q-field>
        <span v-if="currentSession().invalidStart" class="repair-date-helper text-green">
          <q-icon name="fa fa-wrench" color="green" /> Auto-repaired Start Date
        </span>
      </div>
      <div class="sl-col-6 time-container">
        <q-field
          :error="currentValidation().endDate.$error"
          error-label="End Date Required"
          style="width:40%;margin-right:4%"
        >
          <q-datetime
            @blur="currentValidation().endDate.$touch"
            v-model="currentSession().endDate"
            :disable="!canEdit"
            :min="currentSession().startDate"
            :before="[{icon: 'calendar_today' }]"
            inverted-light
            color="grey-3"
            type="date"
            format="MM/DD/YYYY"
            float-label="End Date*"
            popover
          />
        </q-field>
        <q-field
          :error="currentValidation().endHour.$error"
          error-label="Required"
          style="width:15%"
        >
          <q-select
            :disable="!canEdit"
            stack-label="Time*"
            :value="currentSession().endHour"
            @blur="currentValidation().endHour.$touch"
            filter
            autofocus-filter
            :options="hours"
            v-model="currentSession().endHour"
          />
        </q-field>
        <q-field
          :error="currentValidation().endMin.$error"
          error-label="Required"
          style="width:15%"
        >
          <q-select
            :disable="!canEdit"
            float-label=" "
            :value="currentSession().endMin"
            @blur="currentValidation().endMin.$touch"
            filter
            autofocus-filter
            :options="minutes"
            v-model="currentSession().endMin"
          />
        </q-field>
        <q-field
          :error="currentValidation().endPeriod.$error"
          error-label="Required"
          style="width:15%"
        >
          <q-select
            :disable="!canEdit"
            float-label=" "
            :value="currentSession().endPeriod"
            @blur="currentValidation().endPeriod.$touch"
            filter
            autofocus-filter
            :options="period"
            v-model="currentSession().endPeriod"
          />
        </q-field>
        <span v-if="currentSession().invalidEnd" class="repair-date-helper text-green">
          <q-icon name="fa fa-wrench" color="green" /> Auto-repaired End Date
        </span>
      </div>
    </div>

    <div class="sl-row">
      <div class="sl-col-12">
        <h5>
          Location
          <span v-show="!isFirstSession()">
            <q-checkbox :disable="!canEdit" v-model="currentSession().syncAddress"/>
            <span>Sync with First Session</span>
          </span>
        </h5>
      </div>
    </div>
      <div class="sl-row">
        <div class="sl-col-6">
          <q-field
            :error="checkAddressError('address1')"
            error-label="Address is required"
          >
            <q-input
              float-label="Address 1*"
              autocomplete="new-password"
              v-model="currentSessionOrFirst('Address').address1"
              :disable="disableAddressForCurrentSession() || !canEdit"
              v-places-autocomplete="placeChange"
              ref="googleAutocomplete"
            />
          </q-field>
        </div>

        <div class="sl-col-6">
          <q-input
            float-label="Address 2"
            autocomplete="new-password"
            v-model="currentSessionOrFirst('Address').address2"
            :disable="disableAddressForCurrentSession() || !canEdit"
          />
        </div>
      </div>
    
    <div class="sl-row">
      <div class="sl-col-4">
        <q-field 
          error-label="City is required"
          :error="checkAddressError('city')"
        >
          <q-input
            float-label="City*"
            autocomplete="new-password"
            v-model="currentSessionOrFirst('Address').city"
            :disable="disableAddressForCurrentSession() || !canEdit"
          />
        </q-field>
      </div>
      <div class="sl-col-2">
        <q-field
          error-label="State is required"
          :error="checkAddressError('state')"
        >
          <q-select
            :disable="disableAddressForCurrentSession() || !canEdit"
            :ref="'sessionStateDropdown'+currentSessionIndex"
            float-label="State*"
            :value="currentSession().state"
            @focus="onDropdownFocus('sessionStateDropdown'+currentSessionIndex)"
            filter
            autofocus-filter
            :options="stateOptions"
            v-model="currentSessionOrFirst('Address').state"
          />
        </q-field>
      </div>
      <div class="sl-col-3">
        <q-field
          error-label="ZIP Code is required"
          :error="checkAddressError('zip')"
        >
          <q-input
            autocomplete="new-password"
            float-label="Zip*"
            v-model="currentSessionOrFirst('Address').zip"
            :disable="disableAddressForCurrentSession() || !canEdit"
          />
        </q-field>
      </div>
      <div class="sl-col-3">
        <q-field
          error-label="County is required"
          :error="checkAddressError('county')"
        >
          <q-input
            autocomplete="new-password"
            float-label="County*"
            v-model="currentSessionOrFirst('Address').county"
            :disable="disableAddressForCurrentSession() || !canEdit"
          />
        </q-field>
      </div>
    </div>
    
    <div class="sl-row">
      <div class="sl-col-12">
        <h5>Class Type</h5>
      </div>
    </div>
    <div class="sl-row">
      <div class="sl-col-6">
        <q-field>
          <q-select
            :value="sessionInformation.selectedClassType"
            @input="v => onUpdateSelectedClassType(v)"
            float-label="Selected Type"
            map-options
            :after="[
              {icon: 'groups',       condition: sessionInformation.selectedClassType === 1 },
              {icon: 'screen_share', condition: sessionInformation.selectedClassType === 2 }
            ]"
            :disable="!canEdit"
            :options="classTypes"
          />
        </q-field>
      </div>
    </div>
    <div class="sl-row" v-if="sessionInformation.selectedClassType === 2" >
      <div class="sl-col-6">
        <q-input 
          float-label="Meeting Link"
          v-model="sessionInformation.meetingLink"
          :before="[
            {icon: 'link' }
          ]"
          />
          <q-btn v-if="isValidMeetingLink" @click="setMeetingLinkModal(true)" class="q-mt-sm" color="blue" icon="email" label="Share Link" />
        <ShareMeetingLinkModal v-if="meetingLinkModal" v-model="meetingLinkModal" />
      </div>
    </div>

    <div class="sl-row">
      <div class="sl-col-12">
        <h5>Registration Options</h5>
      </div>
    </div>
    <div class="sl-row">
      <div class="sl-col-6" style="min-height: 50px">
        <q-checkbox :disable="!canEdit" v-model="currentSession().registrationOpen"/>
        <span>Allow Registration For this Session</span>
      </div>
      <div class="sl-col-6">
        <q-field          
          helper="(Optional)">
        <q-input
          stack-label="Max # of Students"
          type="number"
          v-model="currentSessionOrFirst('MaxStudents').maxStudents"
          :disable="disableMaxStudentsForCurrentSession() || !canEdit"
          @change="val => setMaxStudents({})"
        />
        </q-field>
        <q-checkbox
          v-if="currentSession(true) != 0"
          :disable="!canEdit"
          v-model="currentSessionOrFirst('MaxStudents').syncMaxStudents"
          
        />
        <span
          v-if="currentSession(true) != 0"
          class="sync-label"
          style="margin-top:15px;display:inline-block"
        >Sync with First Session</span>
      </div>
    </div>
    <div class="sl-row">
      <div class="sl-col-12">
        <h5>
          Additional Information
          <span>(For All Sessions)</span>
        </h5>
      </div>
    </div>
    <div class="sl-row">
      <div class="sl-col-12">
        <q-field
          :error="sessionInformation.selectedCourse == null || sessionInformation.courses.length === 0"
          :error-label="courseErrorLabel"
        >
          <q-select
            v-model="sessionInformation.selectedCourse"
            :after="[
              {icon: 'flag', condition: classValidation.selectedCourse.$invalid },
              {icon: 'fa fa-check', condition: !classValidation.selectedCourse.$invalid}
            ]"
            float-label="Course*"
            :disable="!canEdit || sessionInformation.courses.length === 0"
            :options="getCourses()"
          />
        </q-field>
      </div>
    </div>
    <div class="sl-row">
      <div class="sl-col-12">
        <q-input
          type="textarea"
          inverted-light
          color="grey-12"
          :disable="!canEdit"
          v-model="sessionInformation.notes"
          float-label="Notes"
        />
      </div>
    </div>
    <div class="sl-row">
      <div class="sl-col-12">
        <q-btn
          color="negative"
          v-show="canEdit"
          v-if="!isFirstSession()"
          outline
          icon="delete"
          @click.native="onRemove(currentSession(true))"
        >Delete Session</q-btn>
      </div>
    </div>
  </div>
</template>

<style lang="stylus">
@import '~variables'
.sync-label {
  font-size: 12px;
  display: inline-block;
  padding-right: 10px;
}

.no-affiliate-label {
  color: #ef6270;
  margin-top: 10px;
  display: block;
}

.instructor-field {
  position: relative;

  .q-field {
    padding-right: 45px;
  }

  .delete {
    position: absolute;
    right: 5px;
    top: 15px;
    z-index: 9;
    padding: 7px;
    opacity: 0;
    visibility: invisible;
    @media (max-width: $breakpoint-sm){
      visibility: visible
      opacity 1
    }
  }

  &:hover {
    .delete {
      opacity: 1;
      visiblitity: visible
    }
  }
}

.pac-container {
  z-index: 909999;
}

#class-autocomplete {
  width: 100%;
  height: 0px;
  position: relative;
  top: -25px;
}

.time-container {
  > * {
    float: left;
  }

  .q-datetime-input {
    margin-top: 0 !important;

    .q-icon.q-if-control-before {
      margin-right: 6px;
    }
  }
}
#sessionDetails
  .sl-row
    @media (max-width: $breakpoint-sm)
      margin-bottom 0
.repair-date-helper
  float left
  font-size 12px
</style>
